import { ValidationComponent } from "./pages/validation/validation.component";
import { CaptureImageComponent } from "./pages/capture-image/capture-image.component";
import { ToastrModule } from "ngx-toastr";
import { MatRadioModule } from "@angular/material/radio";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SampleComponent } from "./pages/sample/sample.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatCardModule } from "@angular/material/card";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";

// import { AngularFireDatabaseModule } from "@angular/fire/database";
// import { AngularFireAuthModule } from "@angular/fire/auth";
// import { AngularFireModule } from "@angular/fire";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { environment } from "../environments/environment";

// import {
//   TranslateService,
//   TranslateModule,
//   TranslateLoader,
// } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { EmployeeComponent } from "./pages/employee/employee.component";
import { LocalDatePipe } from "./pages/pipes/local-date.pipe";
import { LocalNumberPipe } from "./pages/pipes/local-number.pipe";
import { DurationDisplayPipe } from "./pages/pipes/duration-display.pipe";
import { CurrencyPipe } from "@angular/common";
import { LoginComponent } from "./pages/login/login.component";
import { RegistrationComponent } from "./pages/registration/registration.component";
import { ViewflowComponent } from "./pages/viewflow/viewflow.component";
import { PerformTaskComponent } from "./pages/perform-task/perform-task.component";
import { GuideQuestionFormEditorComponent } from "./shared/guide-questions/guide-question-form-editor.component";
import { GuideQuestionFormComponent } from "./shared/guide-questions/guide-question-form.component";
import { DataService } from "./Services/dataservice.service";
import { OwlModule } from "ngx-owl-carousel";
import { TermsandconditionsComponent } from "./termsandconditions/termsandconditions.component";
import { PrivacypolicyComponent } from "./privacypolicy/privacypolicy.component";
import { ViewbyidComponent } from "./pages/viewbyid/viewbyid.component";
import { LimitToPipe } from "./limit-to.pipe";
import { FlowByCategoryComponent } from "./pages/flow-by-category/flow-by-category.component";
import { UserProfileComponent } from "./pages/user-profile/user-profile.component";
import { EditProfileComponent } from "./pages/edit-profile/edit-profile.component";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { PreviewPageComponent } from "./pages/preview-page/preview-page.component";
import { EmbedPreviewComponent } from "./pages/embed-preview/embed-preview.component";
import { ForgetPasswordComponent } from "./pages/user-settings/forget-password/forget-password.component";
import { ForgetPasswordModalComponent } from "./pages/forget-password-modal/forget-password-modal.component";
import { ChangePasswordComponent } from "./pages/change-password/change-password.component";
import { ViewProfileComponent } from "./pages/view-profile/view-profile.component";
import { CreateFlowComponent } from "./pages/create-flow/create-flow.component";
import { QRCodeComponent } from "./pages/qrcode/qrcode.component";
import { CommentComponent } from "./pages/comment/comment.component";
import { MatListModule } from "@angular/material/list";
import { EditCommentComponent } from "./pages/edit-comment/edit-comment.component";
import { ChangeOldPasswordComponent } from "./pages/user-settings/change-old-password/change-old-password.component";
import { CoverPageComponent } from "./pages/cover-page/cover-page.component";
import { CategoriesComponent } from "./pages/categories/categories.component";
import { StepsComponent } from "./pages/steps/steps.component";
import { ItemsComponent } from "./pages/items/items.component";
import { YesnodialogComponent } from "./pages/yesnodialog/yesnodialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { MatBadgeModule } from "@angular/material/badge";
import { MatGridListModule } from "@angular/material/grid-list";
import { NotificationsComponent } from "./pages/notifications/notifications.component";
import { CarouselComponent } from "./pages/carousel/carousel.component";
import { NgQrScannerModule } from "angular2-qrscanner";
// import * as firebase from "firebase";
import { DialogExampleComponent } from "./dialog-example/dialog-example.component";
import { SearchComponent } from "./pages/search/search.component";
import { OrgOnboardingComponent } from "./pages/org-onboarding/org-onboarding.component";
import { OrgAdminComponent } from "./pages/org-admin/org-admin.component";
import { OrgJoinComponent } from "./pages/org-join/org-join.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { BulbGuideComponent } from "./pages/bulb-guide/bulb-guide.component";
import { InAppropriateComponent } from "./pages/in-appropriate/in-appropriate.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { AboutUsComponent } from "./pages/about-us/about-us.component";
import { HowItWorksComponent } from "./pages/how-it-works/how-it-works.component";
import { ImageDialogComponent } from "./pages/image-dialog/image-dialog.component";
// import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { UserMentionComponent } from "./pages/user-mention/user-mention.component";
import { PublishDialogComponent } from "./pages/publish-dialog/publish-dialog.component";
import { FollowersComponent } from "./pages/followers/followers.component";
import { FollowingComponent } from "./pages/following/following.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CancalFlowDialogComponent } from "./pages/cancal-flow-dialog/cancal-flow-dialog.component";
import { RestrictedAccessComponent } from "./pages/restricted-access/restricted-access.component";
import { EnhancedRestrictedAccessComponent } from "./pages/enhanced-restricted-access/enhanced-restricted-access.component";
import { FlowAccessRequestComponent } from "./pages/flow-access-request/flow-access-request.component";
import { FlowAccessBlockerComponent } from "./pages/flow-access-blocker/flow-access-blocker.component";
import { EditFlowComponent } from "./pages/edit-flow/edit-flow.component";
import { UserProfileQrCodeComponent } from "./pages/user-profile-qr-code/user-profile-qr-code.component";
import { ShowFlowImageDialogComponent } from "./pages/show-flow-image-dialog/show-flow-image-dialog.component";

import { ScrollSpyDirective } from "./shared/ScrollSpyDirective";
import { BundledialogComponent } from "./pages/bundledialog/bundledialog.component";
import { CreatebundleComponent } from "./pages/createbundle/createbundle.component";
import { AddflowsinBundleComponent } from "./pages/addflowsin-bundle/addflowsin-bundle.component";
import { ViewBundleComponent } from "./pages/view-bundle/view-bundle.component";
import { RestrictedforbundleComponent } from "./pages/restrictedforbundle/restrictedforbundle.component";
import { EditBundleComponent } from "./pages/edit-bundle/edit-bundle.component";
import { DeleteBundleDialogComponent } from "./pages/delete-bundle-dialog/delete-bundle-dialog.component";
import { ReportBundleComponent } from "./pages/report-bundle/report-bundle.component";
import { BundleqrcodeComponent } from "./pages/bundleqrcode/bundleqrcode.component";
import { WelcomedialogComponent } from "./pages/welcomedialog/welcomedialog.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ThirdpartyliabrariesComponent } from "./pages/thirdpartyliabraries/thirdpartyliabraries.component";
import { CommunityGuidelinesComponent } from "./pages/community-guidelines/community-guidelines.component";
import { CookiePolicyComponent } from "./pages/cookie-policy/cookie-policy.component";
import { LawEnforcementComponent } from "./pages/law-enforcement/law-enforcement.component";
import { ActivateaccountComponent } from "./pages/activateaccount/activateaccount.component";

import { ArticleComponent } from "./pages/article/article.component";
import { ShowArticleDialogComponent } from "./pages/show-article-dialog/show-article-dialog.component";
import { AuthInterceptor } from "./auth.interceptor";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { CheckoutComponent } from "./pages/checkout/checkout.component";
import { BaddressComponent } from "./pages/baddress/baddress.component";
import { VouchercodeComponent } from "./pages/vouchercode/vouchercode.component";
import { NgxPayPalModule } from "ngx-paypal";
import { UserDashboardComponent } from "./pages/user-dashboard/user-dashboard.component";
import { EmbededComponent } from "./pages/embeded/embeded.component";
import { EmbedPreviewDialogComponent } from "./pages/embeded/embed-preview-dialog.component";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { EmbedforbundlesComponent } from "./pages/embedforbundles/embedforbundles.component";
import { SupportDocumentComponent } from "./pages/support-document/support-document.component";
import { PdfViewerComponent } from "./pages/pdf-viewer/pdf-viewer.component";
import { ViewUserProfileQrCodeComponent } from "./pages/view-user-profile-qr-code/view-user-profile-qr-code.component";
import { AnalyticsComponent } from "./pages/analyics/analytics.component";
import { EditItemComponent } from "./pages/edit-item/edit-item.component";
import { CouponCodeComponent } from "./pages/user-settings/coupon-code/coupon-code.component";
import { PreviewAuthorComponent } from "./pages/blogs/blogpages/author/author.component";
import { PreviewBlogComponent } from "./pages/blogs/blog/blog.component";
import { PreviewBulletComponent } from "./pages/blogs/blogpages/bullet/bullet.component";
import { PreviewFormattedComponentComponent } from "./pages/blogs/blogpages/formatted-component/formatted-component.component";
import { PreviewImagesComponent } from "./pages/blogs/blogpages/images/images.component";
import { PreviewParagraphComponent } from "./pages/blogs/blogpages/paragraph/paragraph.component";
import { BlogsComponent } from "./pages/blogs/blogs.component";
import { PricingplanComponent } from "./pages/pricingplan/pricingplan.component";
import { CreatorPlanConfirmDialogComponent } from "./pages/pricingplan/creator-plan-confirm-dialog.component";
import { PurchaseCoinsComponent } from "./pages/purchase-coins/purchase-coins.component";
import { PurchaseGuideSlotsComponent } from "./pages/purchase-guide-slots/purchase-guide-slots.component";
import { AiCoinPurchaseDialogComponent } from "./pages/ai-coin-purchase-dialog/ai-coin-purchase-dialog.component";
import { GuideSlotPurchaseDialogComponent } from "./pages/guide-slot-purchase-dialog/guide-slot-purchase-dialog.component";
import { UpgradePlanDialogComponent } from "./pages/upgrade-plan-dialog/upgrade-plan-dialog.component";
import { SubscriptionUsageDialogComponent } from "./pages/subscription-usage-dialog/subscription-usage-dialog.component";
import { PasskeySetupDialogComponent } from "./pages/passkey-setup-dialog/passkey-setup-dialog.component";
import { ExcludeTranslationDirective } from "./shared/excludeTranslationDirective";
import { CarouselModule } from "ngx-owl-carousel-o";
import { QrCodeModule } from "ng-qrcode";
import { QuillModule } from "ngx-quill";
import { DeleteUserDialogComponent } from "./pages/delete-user-dialog/delete-user-dialog.component";
import { SelectionRephraseAIComponent } from "./pages/selection-rephraseAi-dialog/selection-rephraseAi-dialog.component";
import { ThumbnailSelectionDialogComponent } from "./pages/thumbnail-selection-dialog/thumbnail-selection-dialog.component";
import { LoadingModalComponent } from "./pages/loading-modal/loading-modal.component";
import { FaqComponent } from "./pages/faq/faq.component";
import { SupportFaqComponent } from "./pages/support-faqs/support-faqs.component";
import { FaqSupportPageComponent } from "./pages/faq-support-page/faq-support-page.component";
import { CheckoutNavigatorComponent } from "./pages/checkout-navigator/checkout-navigator.component";
import { DonationPopupComponent } from "./pages/donation-popup/donation-popup.component";
import { GiftedfundsComponent } from "./pages/user-dashboard/giftedfunds/giftedfunds.component";
import { SettingsComponent } from "./pages/settings/settings.component";
import { ConsultationsComponent } from "./pages/user-dashboard/consultations/consultations.component";
import { BookconsultationsComponent } from "./pages/bookconsultations/bookconsultations.component";
import { ScheduleconsultationsComponent } from "./pages/user-dashboard/scheduleconsultations/scheduleconsultations.component";
import { MeetLinkDialogComponent } from "./pages/meet-link-dialog/meet-link-dialog.component";
import { FeedbackformsComponent } from "./pages/feedbackforms/feedbackforms.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { BrowserModule, DomSanitizer } from "@angular/platform-browser";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatStepperModule } from "@angular/material/stepper";
import { UserDashboardRoutingModule } from "./pages/user-dashboard/user-dashboard.routing.module";
import { CreateBlogComponent } from "./pages/create-blog/create-blog.component";
import { GenerateKeyword } from "./pages/generate-keyword/generate-keyword.component";
import { ViewReportedFlowComponent } from "./pages/view-reported-flow/view-reported-flow.component";
import { ViewReportedBundleComponent } from "./pages/view-reported-bundle/view-reported-bundle.component";
import { UserAnalyticsComponent } from "./pages/user-analytics/user-analytics.component";
import { UserListDialogComponent } from "./pages/user-list-dialog/user-list-dialog.component";
import { CreatePermissionComponent } from "./pages/create-permission/create-permission.component";
import { ShowPermissionsComponent } from "./pages/show-permissions/show-permissions.component";
import { RequestAccessComponent } from "./pages/request-access/request-access.component";
import { AccessRoleInfoComponent } from "./pages/access-role-info/access-role-info.component";
import { CreateAboutUsComponent } from "./pages/create-about-us/create-about-us.component";
import { SubscriptionsComponent } from "./pages/subscriptions/subscriptions.component";
import { TransferOwnershipComponent } from "./pages/transfer-ownership/transfer-ownership.component";
import { BundleTransferWarningDialogComponent } from "./pages/bundle-transfer-warning-dialog/bundle-transfer-warning-dialog.component";
import { ConfirmBundleRemovalDialogComponent } from "./pages/confirm-bundle-removal-dialog/confirm-bundle-removal-dialog.component";
// import { CreatePoliciesComponent } from './pages/create-policies/create-policies.component';
import { SkeletonLoaderModule } from "./shared/components/skeleton-loader/skeleton-loader.module";
import { SendFeedbackComponent } from "./pages/send-feedback/send-feedback.component";
import { ContactUsComponent } from "./pages/contact-us/contact-us.component";
import { RecaptchaNoticeComponent } from "./shared/components/recaptcha-notice/recaptcha-notice.component";
import { CreateFlowSelectionComponent } from './pages/create-flow-selection/create-flow-selection.component';
import { QuickCreateFlowComponent } from './pages/quick-create-flow/quick-create-flow.component';
import { FlowchestAiCreateFlowComponent } from './pages/flowchest-ai-create-flow/flowchest-ai-create-flow.component';
import { FlowchestAiImportDialogComponent } from './pages/flowchest-ai-import-dialog/flowchest-ai-import-dialog.component';
import { CreateFlowSetupDialogComponent } from './pages/create-flow-setup-dialog/create-flow-setup-dialog.component';
import { CaptionDialogComponent } from './pages/caption-dialog/caption-dialog.component';
import { MediaPreviewDialogComponent } from './pages/quick-create-flow/media-preview-dialog/media-preview-dialog.component';
import { PiecesAiManualFallbackDialogComponent } from './pages/quick-create-flow/pieces-ai-manual-fallback-dialog.component';
import { ItemDetailsDialogComponent } from './pages/item-details-dialog/item-details-dialog.component';
import { AddNewItemDialogComponent } from './pages/add-new-item-dialog/add-new-item-dialog.component';
import { LegalCenterLayoutComponent } from './shared/components/legal-center-layout/legal-center-layout.component';
import { RouterModule } from '@angular/router';
import { FlowCompletionConfirmationComponent } from "./pages/flow-completion-confirmation/flow-completion-confirmation.component";
import { FlowIssueCheckComponent } from "./pages/flow-issue-check/flow-issue-check.component";
import { FlowRatingShortComponent } from "./pages/flow-rating-short/flow-rating-short.component";
import { FlowReviewSubmitComponent } from "./pages/flow-review-submit/flow-review-submit.component";
import { FlowStepIssuesComponent } from "./pages/flow-step-issues/flow-step-issues.component";
import { FlowIssuesDialogComponent } from "./pages/flow-issues-dialog/flow-issues-dialog.component";
import { ReportReviewDialogComponent } from "./pages/report-review-dialog/report-review-dialog.component";
import { FlowThankYouComponent } from "./pages/flow-thank-you/flow-thank-you.component";
import { FlowReviewsListModalComponent } from "./pages/flow-reviews-list-modal/flow-reviews-list-modal.component";
import { CustomerFeedbackSectionComponent } from './pages/customer-feedback-section/customer-feedback-section.component';
import { VersionHistoryPanelComponent } from "./pages/version-history-panel/version-history-panel.component";
import { ContentActivityPanelComponent } from "./pages/content-activity-panel/content-activity-panel.component";
import { ActivityTimelineComponent } from "./shared/components/activity-timeline/activity-timeline.component";
import { VersionRestoreConfirmDialogComponent } from "./pages/version-history-panel/version-restore-confirm-dialog.component";
import { ScheduleViewDialogComponent } from "./pages/schedule-view-dialog/schedule-view-dialog.component";
import { AddConsultationCalendarDialogModule } from "./pages/add-consultation-calendar-dialog/add-consultation-calendar-dialog.module";
import { ConfirmationDialogModule } from "./pages/user-dashboard/transfered-content-approvals/confirmation-dialog/confirmation-dialog.module";
import { LeaveConfirmationDialogModule } from "./shared/components/leave-confirmation-dialog/leave-confirmation-dialog.module";
import { FlowAssistantChatComponent } from "./shared/flow-assistant-chat/flow-assistant-chat.component";
import { CookieConsentComponent } from "./shared/components/cookie-consent/cookie-consent.component";
import { CollaborationRequestsComponent } from "./pages/user-dashboard/collaboration-requests/collaboration-requests.component";

export const firebaseConfig = {
  apiKey: "AIzaSyCf5kewVEMujarBhU1tWFmuzPNvzLQAuT8",
  authDomain: ".firebaseapp.com",
  databaseURL: "https://.firebaseio.com",
  storageBucket: ".appspot.com",
  messagingSenderId: "",
};

// firebase.initializeApp(firebaseConfig);
const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

@NgModule({
  declarations: [
    AppComponent,
    SampleComponent,
    BulbGuideComponent,
    EmployeeComponent,
    SearchComponent,
    LocalDatePipe,
    LocalNumberPipe,
    DurationDisplayPipe,
    InAppropriateComponent,
    LoginComponent,
    RegistrationComponent,
    ViewflowComponent,
    PerformTaskComponent,
    EmbedPreviewComponent,
    TermsandconditionsComponent,
    PrivacypolicyComponent,
    ViewbyidComponent,
    LimitToPipe,
    FlowByCategoryComponent,
    UserProfileComponent,
    EditProfileComponent,
    PreviewPageComponent,
    // ForgetPasswordComponent,
    ForgetPasswordModalComponent,
    ChangePasswordComponent,
    ViewProfileComponent,
    AboutUsComponent,
    HowItWorksComponent,
    CreateFlowComponent,
    QRCodeComponent,
    CommentComponent,
    EditCommentComponent,
    // ChangeOldPasswordComponent,
    CoverPageComponent,
    CategoriesComponent,
    CaptureImageComponent,
    ImageDialogComponent,
    StepsComponent,
    ItemsComponent,
    YesnodialogComponent,
    NotificationsComponent,
    CarouselComponent,
    DialogExampleComponent,
    SearchComponent,
    BulbGuideComponent,
    InAppropriateComponent,
    AboutUsComponent,
    ImageDialogComponent,
    ValidationComponent,
    UserMentionComponent,
    PublishDialogComponent,
    FollowersComponent,
    FollowingComponent,
    CancalFlowDialogComponent,
    RestrictedAccessComponent,
    EnhancedRestrictedAccessComponent,
    FlowAccessRequestComponent,
    FlowAccessBlockerComponent,
    EditFlowComponent,
    UserProfileQrCodeComponent,
    ShowFlowImageDialogComponent,
    ScrollSpyDirective,
    BundledialogComponent,
    ViewReportedFlowComponent,
    ViewReportedBundleComponent,
    CreatebundleComponent,
    AddflowsinBundleComponent,
    ViewBundleComponent,
    RestrictedforbundleComponent,
    EditBundleComponent,
    DeleteBundleDialogComponent,
    ReportBundleComponent,
    BundleqrcodeComponent,
    WelcomedialogComponent,
    ThirdpartyliabrariesComponent,
    CommunityGuidelinesComponent,
    CookiePolicyComponent,
    LawEnforcementComponent,
    ActivateaccountComponent,
    ArticleComponent,
    ShowArticleDialogComponent,
    NotFoundComponent,
    CheckoutComponent,
    BaddressComponent,
    VouchercodeComponent,
    EmbededComponent,
    EmbedPreviewDialogComponent,
    EmbedforbundlesComponent,
    SupportDocumentComponent,
    PdfViewerComponent,
    SupportFaqComponent,
    ViewUserProfileQrCodeComponent,
    AnalyticsComponent,
    EditItemComponent,
    // CouponCodeComponent,
    PricingplanComponent,
    CreatorPlanConfirmDialogComponent,
    PurchaseCoinsComponent,
    PurchaseGuideSlotsComponent,
    AiCoinPurchaseDialogComponent,
    GuideSlotPurchaseDialogComponent,
    UpgradePlanDialogComponent,
    SubscriptionUsageDialogComponent,
    PasskeySetupDialogComponent,
    SubscriptionsComponent,
    BlogsComponent,
    PreviewAuthorComponent,
    PreviewBlogComponent,
    PreviewBulletComponent,
    PreviewParagraphComponent,
    PreviewImagesComponent,
    PreviewFormattedComponentComponent,
    ExcludeTranslationDirective,
    DeleteUserDialogComponent,
    SelectionRephraseAIComponent,
    ThumbnailSelectionDialogComponent,
    LoadingModalComponent,
    FaqComponent,
    FaqSupportPageComponent,
    CheckoutNavigatorComponent,
    DonationPopupComponent,
    // GiftedfundsComponent,
    SettingsComponent,
    // ConsultationsComponent,
    BookconsultationsComponent,
    // ScheduleconsultationsComponent,
    MeetLinkDialogComponent,
    FeedbackformsComponent,
    CreateBlogComponent,
    GenerateKeyword,
    ViewReportedFlowComponent,
    ViewReportedBundleComponent,
    UserAnalyticsComponent,
    UserListDialogComponent,
    CreatePermissionComponent,
    ShowPermissionsComponent,
    RequestAccessComponent,
    AccessRoleInfoComponent,
    CreateAboutUsComponent,
    TransferOwnershipComponent,
    BundleTransferWarningDialogComponent,
    ConfirmBundleRemovalDialogComponent,
    SendFeedbackComponent,
    ContactUsComponent,
    RecaptchaNoticeComponent,
    CreateFlowSelectionComponent,
    QuickCreateFlowComponent,
    FlowchestAiCreateFlowComponent,
    FlowchestAiImportDialogComponent,
    CreateFlowSetupDialogComponent,
    CaptionDialogComponent,
    MediaPreviewDialogComponent,
    PiecesAiManualFallbackDialogComponent,
    ItemDetailsDialogComponent,
    AddNewItemDialogComponent,
    LegalCenterLayoutComponent,
    // CreatePoliciesComponent,
     FlowRatingShortComponent,
    FlowCompletionConfirmationComponent,
    FlowAssistantChatComponent,
    FlowIssueCheckComponent,
    FlowStepIssuesComponent,
    FlowReviewSubmitComponent,
    FlowThankYouComponent,
    FlowReviewsListModalComponent,
    CustomerFeedbackSectionComponent,
    FlowIssuesDialogComponent,
    ReportReviewDialogComponent,
    VersionHistoryPanelComponent,
    ContentActivityPanelComponent,
    ActivityTimelineComponent,
    VersionRestoreConfirmDialogComponent,
    ScheduleViewDialogComponent,
    CookieConsentComponent,
    CollaborationRequestsComponent,
    OrgOnboardingComponent,
    OrgAdminComponent,
    OrgJoinComponent,
  ],
  imports: [
    BrowserModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatButtonModule,
    ScrollingModule,
    DragDropModule,
    AppRoutingModule,

    InfiniteScrollModule,
    //NgQrScannerModule,
    NgxPayPalModule,
    ClipboardModule,
    ToastrModule.forRoot({
      timeOut: 4000,
    }),
    // ZXingScannerModule,
    BrowserAnimationsModule,
    MatSelectModule,
    FormsModule,
    MatBadgeModule,
    MatSidenavModule,
    MatInputModule,
    MatToolbarModule,
    HttpClientModule,
    MatButtonModule,
    MatDialogModule,
    AddConsultationCalendarDialogModule,
    ConfirmationDialogModule,
    LeaveConfirmationDialogModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatIconModule,
    MatListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatTabsModule,
    MatMenuModule,
    MatButtonModule,
    // OwlModule,
    CarouselModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatCheckboxModule,
    MatTableModule,
    MatSlideToggleModule,
    QrCodeModule,
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatStepperModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    QuillModule.forRoot(),
    UserDashboardRoutingModule,
    SkeletonLoaderModule,
    RouterModule,
    GuideQuestionFormEditorComponent,
    GuideQuestionFormComponent,
    // TranslateModule.forRoot({
    //     loader: {
    //         provide: TranslateLoader,
    //         useFactory: HttpLoaderFactory,
    //         deps: [HttpClient],
    //     },
    // }),
  ],
  providers: [
    //TranslateService,
    CurrencyPipe,
    LocalNumberPipe,
    DataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      "copy_link_custom",
      sanitizer.bypassSecurityTrustResourceUrl("assets/icons/copy-link.svg")
    );
    iconRegistry.addSvgIcon(
      "camera_add_custom",
      sanitizer.bypassSecurityTrustResourceUrl("assets/icons/camera-add.svg")
    );
    iconRegistry.addSvgIcon(
      "camera_add_black_custom",
      sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/camera-add-black.svg"
      )
    );
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
